import * as React from 'react';
import {FunctionComponent} from 'react';
import {CalendarEvent} from '../../../../../../Models/CalendarEvent';
import {utcToZonedTime} from 'date-fns-tz';
import {addSeconds, format} from 'date-fns';
import {RsvpResponseBar} from '../../RsvpResponseBar/RsvpResponseBar';

interface OwnProps {
    calendarEvent: CalendarEvent;
    onCalendarEventClick: (calendarEvent: CalendarEvent) => void;
}

export const RsvpCalendarHeader: FunctionComponent<OwnProps> = ({calendarEvent, onCalendarEventClick}) => {
    const startAt = utcToZonedTime(calendarEvent.startAt, calendarEvent.timezone);
    return (
        <div className="calendar-rsvp__cell">
            <div className="calendar-rsvp__header">
                <small>{format(startAt, 'eeeeee d LLL')}</small>
                <h6>
                    {format(startAt, 'H:mm')} - {format(addSeconds(startAt, calendarEvent.duration.seconds), 'H:mm')}
                </h6>
                <button className="calendar-rsvp__event" onClick={() => onCalendarEventClick(calendarEvent)}>
                    {calendarEvent.title}
                </button>
                <RsvpResponseBar calendarEvent={calendarEvent} />
            </div>
        </div>
    );
};
